import { render, staticRenderFns } from "./FormCardRows.vue?vue&type=template&id=74464b08&"
import script from "./FormCardRows.vue?vue&type=script&lang=js&"
export * from "./FormCardRows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports